import * as yup from 'yup';

export const schema:any = yup.object().shape({
  companyName: yup.string().required('The Company Name field is required.'),
  yourFirstName: yup.string().required('The Your First Name field is required.'),
  yourLastName: yup.string().required('The Your  Last Name field is required.'),
  yourEmail: yup.string().email('The Your Email field is not valid.').required('The Your Email field is required.'),
});
